export const DEFAULT_SCRIPT = `component|box;

time=0{
  show|box;
  size|box|width=180,height=100;
  position|box|x=710,y=400,z=1;
  background|box|color="#22d3ee";
  radius|box|tl=14,tr=14,bl=14,br=14;
  text|box|value="Hello",size=24,weight=700,color="#06202a",align="center";
}`;

